<template>
    <div class="apaasCloudPartner introduce-container">
        <h3
            class="apaasCloud-title"
            style="opacity: 0.85;"
        >多家政府和企业客户信赖之选</h3>
        <!-- <p class="apaasCloud-subtitle">覆盖基建、地产、金融、银行、交通、新零售等数10个行业</p> -->
        <div class="apaasCloudPartner-casual">
            <div
                :ref="'casualMove'"
                class="casual-move"
                :style="activeLeftStyle"
            >
                <div
                    v-for="(pic, index) in imgList"
                    :key="index"
                    class="apaasCloudPartner-casual-double"
                >
                    <template v-if="index % 2 == 0">
                        <img :src="imgList[index]"><img :src="imgList[index+1]">
                    </template>
                </div>
            </div>
            <Icon
                @click="moveFunc('back')"
                class="casual-back"
                type="ios-arrow-back"
            />
            <Icon
                @click="moveFunc('forward')"
                class="casual-forward"
                type="ios-arrow-forward"
            />
            <div class="shadow-left"></div>
            <div class="shadow-right"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "apaasCloudPartner",
        components: {},
        data () {
            return {
                imageNameList: ["fagaiwei", "caizhengbu", "zhujianbu", "caizhengshehui", "hbfagaiwei", "xjfagaiwei", "bjjiaotongwei", "scjiaotongting", "gzjiaotongting",
                                "gsjiaotongting", "zhongjian", "zhongjiao", "zhongtie", "zhongtiejian", "zhonghua", "pinganjinrong", "jianhang", "gonghang", "pingan",
                                "nongfa", "worldbank", "aiib", "aifc", "beida", "qinghua", "beikong", "shouchuang", "jiashi",
                                "zhonglian", "zhaoshang", "huatai"],
                moveStep: 0,
                activeLeftStyle: {},
                moveDirection: "forward"
            };
        },
        computed: {
            imgList () {
                return this.imageNameList.map(item => this.$imageSrcMap.introduction.apaas[item]);
            },
            imgListEven () {
                return this.imgList.filter((item, index) => index % 2 === 0);
            }
        },
        created () {
            this.autoPlay();
        },
        methods: {
            moveFunc (direction) {
                this.moveDirection = direction;
                let showImgLen = 5;
                if (direction === "back") {
                    if (this.moveStep === 0) {
                        this.moveStep = parseInt(this.imgList.length / 2 - showImgLen);
                    }
                    this.moveStep = (this.moveStep - 1) % (parseInt(this.imgList.length / 2 - showImgLen));
                } else {
                    this.moveStep = (this.moveStep + 1) % (parseInt(this.imgList.length / 2 - showImgLen));
                }
                this.getMoveStyle();
            },
            autoPlay () {
                this.$nextTick(() => {
                    this.timer = setInterval(() => {
                        this.moveFunc(this.moveDirection);
                    }, 5000);
                });
            },
            getMoveStyle () {
                let dom = null;
                this.$nextTick(() => {
                    dom = this.$refs["casualMove"];
                    if (!dom) {
                        this.activeLeftStyle = {};
                        return;
                    }
                    let activeLeftStyle = {
                        left: 0 - this.moveStep * 255 + "px"
                    };
                    this.activeLeftStyle = activeLeftStyle;
                });
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/views/introduction/apaasCloud/apaasCloudPartner.vue